module.exports = __webpack_public_path__ + "images/effa8b99a2ee7b5cf9600f8a7f05953f.svg";